/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';

import { DialogRef } from '@ngneat/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

import { UserService } from '@app/modules/core/services/user/user.service';
import {
  StartLoadingAction,
  StopLoadingAction,
} from '@app/modules/core/states/app-state/app.actions';

import { requiredEmail } from '../../validators';

@UntilDestroy()
@Component({
  selector: 'bkg-recovery-pass-dialog',
  templateUrl: './recovery-pass-dialog.component.html',
})
export class RecoveryPassDialogComponent implements OnInit {
  form: FormGroup;
  errorText: string;
  feedbackOK = false;
  sendedEmail: string;

  constructor(
    public ref: DialogRef,
    private fb: FormBuilder,
    private userService: UserService,
    private translateService: TranslateService,
    private store: Store
  ) {}

  get isButtonDisabled(): boolean {
    return this.form?.invalid;
  }

  ngOnInit(): void {
    this.initForm();
  }

  onClickSendMail(): void {
    const email = this.getControlValue('email') as string;
    this.store.dispatch(new StartLoadingAction());
    this.userService
      .resetPassword(email)
      .pipe(untilDestroyed(this))
      .subscribe(
        () => {
          this.sendedEmail = email;
          this.feedbackOK = true;
          this.store.dispatch(new StopLoadingAction());
        },
        (error: HttpErrorResponse) => {
          const errMessage = error?.error?.reason
            ? (error?.error?.reason as string)
            : (this.translateService.instant('common.standardError') as string);
          this.errorText = errMessage;
          this.store.dispatch(new StopLoadingAction());
        }
      );
  }

  onClickClose(): void {
    this.ref.close(false);
  }

  hasErrors(fieldName: string): boolean {
    const control = this.getControl(fieldName);
    return !!control?.invalid && !!control?.touched;
  }

  isValidField(fieldName: string): boolean {
    const control = this.form.get(fieldName);

    return !!control?.valid;
  }

  private initForm(): void {
    this.form = this.fb.group({
      email: [null, requiredEmail],
    });
  }

  private getControl(controlName: string): AbstractControl {
    return this.form.get(controlName);
  }

  private getControlValue(controlName: string): unknown {
    return this.getControl(controlName).value as unknown;
  }
}
